import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useGetCoupons = (): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.GET_COUPONS], {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
    notifyOnChangeProps: [
      "data",
      "error",
      "refetch",
      "isRefetching",
      "isSuccess",
      "isLoading",
    ],
  });
};
